import { render, staticRenderFns } from "./newsSimplify.vue?vue&type=template&id=49509eec&scoped=true&"
import script from "./newsSimplify.vue?vue&type=script&lang=js&"
export * from "./newsSimplify.vue?vue&type=script&lang=js&"
import style0 from "./newsSimplify.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsSimplify.vue?vue&type=style&index=1&id=49509eec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49509eec",
  null
  
)

export default component.exports